import { render, staticRenderFns } from "./JobTitlesList.vue?vue&type=template&id=23aba142&"
import script from "./JobTitlesList.vue?vue&type=script&lang=js&"
export * from "./JobTitlesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports